<script>
  import katexify from "../katexify";
  import { llProbability, yVal } from "../data-store";
  import Scatterplot from "./LogLossScatter.svelte";

  let llScatterClass;

  const log_loss =
    "\\textrm{Log-Loss} = \\sum_{i=0}^n - (y_i * \\textrm{log}(p_i) + (1-y_i)*\\textrm{log}(1-p_i))";

  const items = [
    { value: true, label: "y = 0" },
    { value: false, label: "y = 1" },
  ];

  let chosen = items[0];

  function handleSelect(event) {
    chosen = event.detail;
    $yVal = chosen.value;
  }

  function handleClear() {
    chosen = undefined;
  }
</script>

<section>

  <div id="ll-container">
    <div id="equations-container">
      <div class="input-container">
        <label for="true-select" style="line-height: 40px;"><span class="bold">Select true value for {@html katexify("y")}: </span></label>
        <div class="container" style="display: flex; gap: 12px;">
          <button
            class="y-btn {($yVal === true ? 'active' : '')}"
            on:click={() => $yVal = true}
            aria-pressed={$yVal === true}
            type="button"
          >
            y = 0
          </button>
          <button
            class="y-btn {($yVal === false ? 'active' : '')}"
            on:click={() => $yVal = false}
            aria-pressed={$yVal === false}
            type="button"
          >
            y = 1
          </button>
        </div>
      </div>
      <div id="probability-slider">
        <div class="input-container">
          <label for="slider1" class="float-left">
            <span class="bold">Probability:</span> {$llProbability}
          </label>
          <input
            type="range"
            min="0.01"
            max="0.99"
            step="0.01"
            bind:value={$llProbability}
            class="slider"
            id="slider1"
          />
        </div>
      </div>
    </div>
    <div id="charts-container">
      <div id="ll-chart">
        <Scatterplot bind:this={llScatterClass} />
      </div>
    </div>
  </div>
  <br /><br />
</section>

<style>
  section {
    margin: 0 auto;
    padding: 0;
    max-width: 1000px;
  }

  #ll-container {
    display: grid;
    grid-template-columns: 50% 50%;
    font-family: var(--font-main);
    margin: 0;
    width: 100%;
    max-width: 1000px;
    height: 500px;
    justify-content: center;
    align-items: center;
  }

  #equations-container {
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 500px;
  }

  #buttons-container {
    display: flex;
    margin: 8px auto;
    justify-content: space-around;
    align-items: center;
    width: 90%;
  }

  .input-container {
    display: flex;
    flex-direction: row;
    margin: 0 auto;
    width: 80%;
    align-items: center;
  }

  button {
    background-color: var(--secondary); /* Green */
    border: none;
    color: var(--paper);
    padding: 8px 16px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 14px;
    margin: 4px 2px;
    cursor: pointer;
    opacity: 0.9;
  }

  button:hover {
    outline: 1px solid var(--squidink);
  }

  button:active {
    color: var(--squidink);
  }

  button:visited {
    color: var(--white);
  }

  .y-btn {
    flex: 1;
    padding: 10px 0;
    background: var(--paper);
    border: 2px solid var(--squidink);
    border-radius: 6px;
    color: var(--squidink);
    font-size: 1rem;
    font-family: var(--font-main);
    cursor: pointer;
    transition: background 0.2s, color 0.2s, border 0.2s;
    outline: none;
  }

  .y-btn.active, .y-btn:active {
    background: var(--sky);
    color: var(--white);
    border-color: var(--sky);
  }

  #charts-container {
    display: grid;
    grid-template-columns: 100%;
    grid-column-gap: 0rem;
    grid-template-rows: 100%;
    padding-right: 1rem;
    height: 500px;
  }

  .slider {
    -webkit-appearance: none;
    width: 100%;
    height: 15px;
    border-radius: 5px;
    background: var(--paper);
    outline: none;
    opacity: 0.9;
    -webkit-transition: 0.2s;
    transition: opacity 0.2s;
    border-color: var(--squidink);
    vertical-align: middle;
    margin-top: 16px;
  }

  .slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: var(--sky);
    cursor: pointer;
  }

  label {
    width: 100%;
    color: var(--squidink);
    line-height: 42px;
    vertical-align: middle;
  }

  #equation-math {
    color: var(--squidink);
  }

  .true-select {
    width: 100%;
    vertical-align: middle;
    margin-bottom: 10px;
    margin-top: 10px;
    background-color: var(--paper);
    text-align: center;
  }

  .container {
    width: 100%;
  }

  /* mobile */
  @media screen and (max-width: 950px) {
    #ll-container {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: auto;
      margin: 0;
      padding: 0;
    }

    #equations-container {
      height: auto;
      margin-bottom: 20px;
    }

    #charts-container {
      width: 100%;
      height: 450px;
      padding-right: 0;
    }

    .input-container {
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
      margin: 10px auto;
    }

    label {
      width: auto;
      margin-bottom: 10px;
    }

    .container {
      width: 100%;
      justify-content: center;
    }

    .y-btn {
      min-width: 80px;
    }
  }
</style>
